module.exports = __webpack_public_path__ + "img/bramble.562d126b.jpg";